<template>
  <v-container>
    <h1 class="headline pa-2">
      <span class="mr-5">Analytics</span>
    </h1>
    <v-card class="pa-5">
      <span>Global Date Controls</span>
      <v-row>
        <v-flex class="pa-3">
          <v-text-field label="Lower Bound Date" v-model="startDate" type="date"></v-text-field>
        </v-flex>
        <v-flex class="pa-3">
          <v-text-field label="Upper Bound Date" v-model="endDate" type="date"></v-text-field>
        </v-flex>
      </v-row>
      <v-btn dark color="orange" outlined @click="initialDataQuery()" :loading="initialLoad">Gather Data</v-btn>
    </v-card>

    <v-card class="pa-5" >
      <span class="title">Real-time Data</span>
      <v-card flat height="100" width="125" outlined class="text-center ma-5 pa-3" v-if="records.length > 0">
        <span>Total Cards</span>
        <div class="display-1">{{logNumber}}</div>
      </v-card>
    </v-card>

    <v-card class="pa-5" >
      <span class="title">Usage Data By Date</span>
      <v-card max-width="500" flat v-if="records.length > 0">
        <LineChart :chartData="chartData" :options="chartOptions"/>
      </v-card>
    </v-card>

    <v-card class="pa-5">
      <span class="title">Usage Data By Deck</span>
      <v-data-table v-if="useCounts" :headers="tableHeaders" :items="useCounts"></v-data-table>
    </v-card>
  </v-container>

</template>
<script>
import db from '@/fb'
import _ from 'underscore'
import moment from 'moment'
import LineChart from '@/components/LineChart.vue'

export default {
  name: 'Analytics',
  components: {LineChart},
  data() {
    return {
      initialLoad: false,
      records: [],
      logNumber: 0,
      startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      endDate: moment().add(1, 'days').format('YYYY-MM-DD'),
      decks: {},
      useCounts: null,
      tableHeaders: [
        {text: 'Subject', value: 'subject'},
        {text: 'Name', value: 'name'},
        {text: 'New', value: 'new'},
        {text: 'Review', value: 'review'},
        {text: 'Know', value: 'know'},
        {text: 'Know %', value: 'knowPercent'},
        {text: 'Total', value: 'total'},
        {text: 'Users', value: 'uniqueUsers'}
      ],
      chartOptions: {
  				responsive: true,
  				title: {
  					display: true,
  					text: 'Omentum Use'
  				},
  				scales: {
  					xAxes: [{
  						type: 'time',
              time: {
                unit: 'day',
              },
  						display: true,
  						scaleLabel: {
  							display: true,
  							labelString: 'Date'
  						},
  						ticks: {
                min: moment().subtract(8, 'days').format(),
                max: moment().add(1, 'days').format(),
  						}
  					}],
  					yAxes: [{
  						display: true,
  						scaleLabel: {
  							display: true,
  							labelString: 'Number of cards'
  						}
  					}]
  				}
  			},
        chartData: {
          labels: ['date'],
          datasets: [
            {
    					label: 'Cards By Hour',
              backgroundColor: 'rgb(235, 151, 78, 1)',
              borderColor: 'rgb(235, 151, 78, 1)',
    					fill: false,
              data: [
                {x: moment().format(), y: 10}
              ]

    			}]
        },
    }
  },
  computed: {

  },
  mounted() {


  },
  methods: {
    // queryTest() {
    //   console.log('test')
    //   firebase.firestore().collection('logsV2').orderBy('timestamp', "desc").limit(200).get().then(result => {
    //     result.forEach(doc => {
    //       console.log(doc.data().timestamp.toDate())
    //       console.log(doc.data().uid)
    //     })
    //   })
    // },
    initialDataQuery() {
      this.initialLoad = true
      Promise.all([
        this.getLogData(),
        this.getDeckData(),
        this.countLogRecords()
      ]).then(() => {
        this.initialLoad = false
        console.log(this.records.length)
        this.useCounts = this.generateUseCounts(this.records)

        this.chartOptions.scales.xAxes[0].ticks.min = moment(this.startDate).format()
        this.chartOptions.scales.xAxes[0].ticks.max = moment(this.endDate).format()
        this.buildGraphData()
      })
    },
    countLogRecords() {
      firebase.firestore().collection("logsV2").onSnapshot(snapshot => {
        this.logNumber = snapshot.size
      });
    },
    getLogData() {
      return firebase.firestore().collection("logsV2")
        .where('timestamp', '>', moment(this.startDate).toDate())
        .where('timestamp', '<=', moment(this.endDate).toDate())
        .get().then(snapshot => {
        snapshot.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.records.push(data)
          return ""
        })
        console.log({'logData': this.records})
      })
    },
    getDeckData() {
      return firebase.firestore().collection("decks").get().then(snapshot => {
        snapshot.forEach(deck => {
          this.decks[deck.id] = deck.data()
        })
      })
    },
    findHardCards(data) {
      let grouping = _.groupBy(data, entry => {return entry.cardId})
      for (let item in grouping) {
        grouping[item] = this.groupDataByKnowledge(grouping[item])
      }
      for (let item in grouping) {
        let entries = grouping[item]
        for (let entry in entries) {
          entries[entry] = entries[entry].length
        }
      }

      let array = []

      for (let item in grouping) {
        if ('0' in grouping[item]) {
          array.push({
            card: item,
            count: grouping[item][0],
          })
        }
        else {
          array.push({
            card: item,
            count: 0,
          })
        }
      }
      array = _.sortBy(array, 'count').reverse()
      return array

    },
    generateUseCounts(data) {
      let users = this.groupDataByDeck(data)
      for (let item in users) {
        users[item] = Object.keys(_.groupBy(users[item], entry => {return entry.uid})).length
      }


      let decks = this.groupDataByDeck(data)
      for (let item in decks) {
        decks[item] = this.groupDataByKnowledge(decks[item])
      }
      for (let item in decks) {
        let entries = decks[item]
        for (let entry in entries) {
          entries[entry] = entries[entry].length
        }
      }
      let tableData = []
      for (let item in decks) {
        let tableEntry = {}
        let sum = 0
        let entries = decks[item]
        try {
          for (let entry in entries) {
            sum += entries[entry]
            if (entry == 0) {
              tableEntry['new'] = entries[entry]
            }
            else if (entry == 1) {
              tableEntry['review'] = entries[entry]
            }
            else if (entry == 2) {
              tableEntry['know'] = entries[entry]
            }
          }
          tableEntry['subject'] = this.decks[item].subject
          tableEntry['name'] = this.decks[item].name
          tableEntry['total'] = sum
          tableEntry['knowPercent'] = Math.round((tableEntry['know']) / sum * 100, 2)

          tableEntry['uniqueUsers'] = users[item]

          tableData.push(tableEntry)
        }
        catch {
          console.log('problem with:', item)
        }

      }
      return tableData
    },
    groupDataByDeck(data) {
      let grouping = _.groupBy(data, function(entry) {return entry.deckId})
      return grouping
    },
    groupDataByKnowledge(data) {
      let grouping = _.groupBy(data, function(entry) {return entry.result})
      return grouping
    },
    buildHourByHourXY(data) {
      let hours = _.groupBy(data, entry => {return moment(entry.timestamp.toDate()).format('YYYY-MM-DD-HH')})
      let result = []
      for (let item in hours) {
        result.push({
          x: moment(item, 'YYYY-MM-DD-HH').format(),
          y: hours[item].length
        })
      }
      return result
    },
    generateAggregateXY(data) {
      let sorted = _.sortBy(data, 'x')
      let sum = 0
      sorted.forEach(item => {
        sum += item.y
        item.y = sum
      })
      return sorted
    },
    buildGraphData() {
      let graphObject = {
        labels: ['date'],
        datasets: [
          {
            label: 'Cards By Hour',
            backgroundColor: 'rgb(235, 151, 78, 1)',
            borderColor: 'rgb(235, 151, 78, 1)',
            fill: false,
            data: this.generateAggregateXY(this.buildHourByHourXY(this.records))
        }]
      }
      this.chartData = graphObject
    }
  }
}
</script>
<style>

</style>
